<template>
  <div
    v-show="isNavigationOpen"
    data-testid="navigationContainer"
    class="absolute top-0 w-full h-full lg:top-auto overflow-auto bg-EXPONDO-white"
  >
    <div
      data-testid="navigationBackdrop"
      class="max-lg:hidden w-full h-screen top-0 left-0 absolute bg-EXPONDO-black opacity-50 z-20"
      @click="toggleNavigation"
    />
    <div
      v-for="firstLevelCategories in categoriesContainer"
      :key="firstLevelCategories.slug"
      class="nav-container w-full h-full lg:h-auto bg-EXPONDO-white z-40 flex relative p-3 lg:overflow-auto
        lg:max-w-[calc(100%-8rem)] lg:max-h-[calc(100vh-10rem)] lg:mx-auto"
    >
      <NavSidebar
        :first-level-categories="firstLevelCategories.children"
        class="w-full h-full lg:w-[30%] lg:border-r border-EXPONDO-grey-3 lg:p-3 bg-EXPONDO-white"
        :class="{
          'max-lg:hidden': hasSelectedFirstLevelCategory
        }"
        :has-schema="true"
      />
      <NavBody
        v-show="hasSelectedFirstLevelCategory"
        :first-level-categories="firstLevelCategories.children"
        class="w-full h-auto lg:w-[70%]"
      />
      <NavMainCategories
        v-show="!hasSelectedFirstLevelCategory"
        class="max-lg:hidden p-12 lg:w-[70%]"
        :first-level-categories="firstLevelCategories.children"
        :has-schema="true"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, type PropType } from 'vue';
import { useNavigationState } from '~/composables/useNavigationState';
import type { Category } from '~~/types/commercetools';
import NavBody from './NavBody.vue';
import NavSidebar from './NavSidebar.vue';
import NavMainCategories from '~/components/molecules/Navigation/NavMainCategories/NavMainCategories.vue';

export default defineComponent({
  name: 'NavigationContent',

  components: {
    NavBody,
    NavSidebar,
    NavMainCategories,
  },

  props: {
    categoriesContainer: {
      type: Array as PropType<Category[]>,
      default: () => {

        return [];

      },
    },
  },

  setup() {

    const {
      currentFirstLevelCategorySlug,
      isNavigationOpen,
      toggleNavigation,
    } = useNavigationState();

    const hasSelectedFirstLevelCategory = computed(() => Boolean(currentFirstLevelCategorySlug.value));

    return {
      hasSelectedFirstLevelCategory,
      isNavigationOpen,
      toggleNavigation,
    };

  },
});

</script>